// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"219":"3e14c27a","750":"6096d797","918":"0f13bf1e"}[chunkId] + ".chunk.js";
};